import { render, staticRenderFns } from "./tzjg.vue?vue&type=template&id=468d3d1c&"
import script from "./tzjg.vue?vue&type=script&lang=js&"
export * from "./tzjg.vue?vue&type=script&lang=js&"
import style0 from "./tzjg.vue?vue&type=style&index=0&scpoed=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports